import { css } from 'styled-components';

export const iconColor = (color, important = false) => css`
  *[fill]:not([fill="white"]):not([fill="none"]) {
    fill: ${color}${important ? ' !important' : ''};
  }

  *[stroke]:not([stroke="white"]):not([stroke="none"]) {
    stroke: ${color}${important ? ' !important' : ''};
  }
`;

export const warningBadgeIcon = css`
  rect {
    fill: #FAAD14 !important;

    & + path {
      stroke: ${props => props.theme.colors.neutral_1} !important;
      fill: ${props => props.theme.colors.neutral_1} !important;
    }
  }
`;
